export default class Gift {
  consumableID: number;
  description: string;
  groupName: string;
  imageURL: string;
  name: string;
  price: number;
  type: string;
  data: string;
  diamonds: number;
  category: string;
  level: number;
  constructor() {
    this.consumableID = 0;
    this.description = '';
    this.groupName = '';
    this.imageURL = 'https://ak.picdn.net/shutterstock/videos/1082827489/thumb/9.jpg?ip=x480';
    this.name = '';
    this.price = 0;
    this.type = '';
    this.data = 'https://assets3.lottiefiles.com/packages/lf20_XZ3pkn.json';
    this.diamonds = 0;
    this.category = '';
    this.level = 1;
  }

  static mappingGift(_g: any) {
    const g = new Gift();
    if (_g) {
      g.consumableID = _g.ConsumableID;
      g.description = _g.Description;
      g.groupName = _g.GroupName;
      g.imageURL = _g.ImageURL || 'https://ak.picdn.net/shutterstock/videos/1082827489/thumb/9.jpg?ip=x480';
      g.name = _g.Name;
      g.price = _g.Price || 0;
      g.type = _g.Type;
      g.data = _g.Data || 'https://assets3.lottiefiles.com/packages/lf20_XZ3pkn.json';
      g.diamonds = _g.Diamonds || 0;
      g.category = _g.Category || '';
      g.level = _g.Level || 1;
    }
    return g;
  }

  static mappingGifts(_a: any[]): Gift[] {
    return _a?.map(g => Gift.mappingGift(g)) || [];
  }
}
